"use client"

import GeneralError from "~/components/errors/500"

export default function Error() {
    return <GeneralError />
}